import {
  addNew,
  addNewLg,
  depts,
  deptsLg,
  payments,
  paymentsFilter,
  people,
  peopleLg,
  accountSettings,
  aiQuiz,
  gamesPage,
  learnPage,
  profileSettings,
  tracks,
  trackContent,
  landing,
  headerDarksm,
  headerLightsm,
  heroDark,
  heroLight,
  projectDrawer,
} from '../assets/projects2.js';


const moneyCircle = {
  title: 'Money Circle',
  technologies: ['# React.js', '# JSON Server', '# Material-UI'],
  description: [
    <div key="1">
      Developed a{' '}
      <span className="highlight-text font-bold">4-page web application</span>{' '}
      to simplify expense tracking and settlement for groups.
    </div>,
    <div key="2">
      <span className="highlight-text font-bold">Add Payment Page:</span> Allows
      users to add payments through a Material-UI form with dynamic participant
      selection.
    </div>,
    <div key="3">
      <span className="highlight-text font-bold">Payments Display Page:</span>{' '}
      Displays all payments in a visually appealing card-based layout using the
      magiccard library. Features include delete functionality with confirmation
      dialogs, filtering by participant, and sorting by time (latest or oldest
      first).
    </div>,
    <div key="4">
      <span className="highlight-text font-bold">Debts Page:</span> Shows a
      clear visual representation of who owes money to whom with an intuitive
      arrow-based design.
    </div>,
    <div key="5">
      <span className="highlight-text font-bold">People Page:</span> Enables
      adding and removing users with unique usernames for effective group
      management.
    </div>,
    <div key="6">
      Built using <span className="highlight-text">React.js</span> for the
      frontend and <span className="highlight-text">JSON Server</span> as a
      temporary backend for seamless data handling.
    </div>,
    <div key="7">
      Planned future enhancements include adding{' '}
      <span className="highlight-text">authentication</span> and deploying the
      app for public use.
    </div>,
  ],
  coverImg: payments, // Replace with the actual cover image variable
  images: [
    addNew,
    depts,
    deptsLg,
    payments,
    addNewLg,
    paymentsFilter,
    people,
    peopleLg,
  ], // Replace with your images
  actionText: 'Open Demo',
  actionLink: 'https://money-circle.vercel.app',
};

const bassathaProject = {
  title: 'Bassatha Learning Platform',
  technologies: [
    '# ReactJS',
    '# Node.js',
    '# MongoDB',
    '# ContextAPI',
    '# Axios',
  ],
  description: [
    <div key="1">
      Developed a full-stack learning platform designed to provide structured
      programming tracks and curated YouTube courses as{' '}
      <span className="highlight-text font-bold">roadmaps for learners</span>.
    </div>,
    <div key="2">
      Led the team in defining{' '}
      <span className="highlight-text">project guidelines</span>, file
      structure, routes, and application architecture, ensuring smooth
      collaboration and high-quality results.
    </div>,
    <div key="3">
      Managed the GitHub repository by maintaining{' '}
      <span className="highlight-text">clean, organized code</span>, resolving
      merge conflicts, and documenting project structure in a detailed{' '}
      <span className="highlight-text">README.md</span>.
    </div>,
    <div key="4">
      Implemented user authentication and authorization features using{' '}
      <span className="highlight-text">Axios Interceptors</span> and{' '}
      <span className="highlight-text">ContextAPI</span>, ensuring secure
      session management and data flow.
    </div>,
    <div key="5">
      Built a <span className="highlight-text">dynamic Settings page</span> that
      enables users to update profiles and account details with seamless backend
      integration.
    </div>,
    <div key="6">
      Optimized application performance using{' '}
      <span className="highlight-text">React.lazy()</span> and{' '}
      <span className="highlight-text">{'<Suspense>'}</span> for efficient page
      and layout loading.
    </div>,
    <div key="7">
      Coordinated project sprints and team workflows using{' '}
      <span className="highlight-text">Jira and GitHub</span>, ensuring timely
      delivery of features and alignment with best practices.
    </div>,
  ],
  coverImg: landing,
  images: [
    accountSettings,
    aiQuiz,
    gamesPage,
    learnPage,
    profileSettings,
    tracks,
    trackContent,
  ],
  actionText: 'See It Live',
  actionLink: 'https://bassatha-learn.web.app',
};

const portfolioProject = {
  title: 'Personal Portfolio Website',
  technologies: ['# ReactJS', '# TailwindCSS', '# Material UI', '# Firebase'],
  description: [
    <div key="1">
      Built a modern, responsive portfolio website with a{' '}
      <span className="highlight-text">dynamic light/dark theme toggle</span> to
      enhance user experience and accessibility.
    </div>,
    <div key="2">
      Showcased projects in a{' '}
      <span className="highlight-text">responsive grid layout</span>, with a
      drawer displaying detailed project information and an image carousel for
      project screenshots.
    </div>,
    <div key="3">
      Implemented an <span className="highlight-text">image zoom feature</span>{' '}
      for non-touchable screens, enhancing visual interactivity using an
      integrated image viewer.
    </div>,
    <div key="4">
      Deployed the website on <span className="highlight-text">Firebase</span>,
      ensuring reliable hosting and fast performance.
    </div>,
    <div key="5">
      Followed <span className="highlight-text">best practices</span> by
      splitting UI into reusable components like buttons, drawers, and
      higher-order components (HOCs) for better maintainability and scalability.
    </div>,
  ],
  coverImg: heroDark,
  images: [
    headerDarksm,
    headerLightsm,
    heroDark,
    heroLight,
    projectDrawer,
  ],
  actionText: 'You are seeing it live',
  // actionLink: 'https://abdullah-ashraf.web.app',
};

export default [moneyCircle, bassathaProject, portfolioProject];
